import React, { useEffect } from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import { useNavigate } from "react-router-dom";

import freshstartImage from "../Images/freshstart2.jpg";
import speakmind from "../Images/speakmind2.jpg";
import English from "../Images/English2.jpg";
import key from "../Images/key2.jpg";
import ditation from "../Images/ditation2.jpg";
import vocaboost from "../Images/vocaboost2.jpg";
import intonation from "../Images/intonation2.jpg";
import ielts from "../Images/ielts2.jpg";
import './CourseCard.css';
import Aos from "aos";

const courses = [
  {
    id: 1,
    image: freshstartImage,
    title: "Fresh Start",
    description:
      "<b>Pronounce any English word correctly and handle your pronunciation effortlessly with our <b style='color:red;'>Fresh Start</b> workshop.</b>",
    level: "Beginner",
    lessons: 11,
    students: 227,
    details: "Pronounce any English word correctly and handle your pronunciation...",
  },
  {
    id: 2,
    image: speakmind,
    title: "Speak Your Mind",
    description:
      "<b>Start speaking in English and build your confidence in <b style='color:red;'>Speak Your Mind</b>. Learn on the go and break the language barrier.</b>",
    level: "Intermediate",
    lessons: 11,
    students: 227,
    details: "Start speaking in English and build your confidence in...",
  },
  {
    id: 3,
    image: English,
    title: "English At Work",
    description:
      "<b><b style='color:red;'>English at Work</b> is a Business English course crafted to help you deliver presentations, attend seminars, and communicate effectively.</b>",
    level: "Expert",
    lessons: 11,
    students: 227,
    details: "English at Work is a Business English course crafted to help you deliver...",
  },
  {
    id: 4,
    image: key,
    title: "Phono KEY",
    description:
      "<span style='color:red;'>Phono Key</span> is a video course that provides real-life examples.<b> Speak fluently and understand other speakers clearly.</b>",
    level: "Beginner",
    lessons: 11,
    students: 227,
    details: "Phono Key is a video course that provides real-life examples. Speak fluently and...",
  },
  {
    id: 5,
    image: ditation,
    title: "Dictation Course",
    description:
      "Develop your listening and build your vocabulary. This <b>unique <b style='color:red;'> dictation course</b></b> is not available anywhere else.",
    level: "Hard",
    lessons: 11,
    students: 227,
    details: "Develop your listening and build your vocabulary. This unique dictation course...",
  },
  {
    id: 6,
    image: intonation,
    title: "Intonation Course",
    description:
      "<b>Sound natural in English and master the correct accent with The <b style='color:red;'>Intonation Course.</b> Convey your messages with ease.</b>",
    level: "Intermediate",
    lessons: 11,
    students: 227,
    details: "Sound natural in English and master the correct accent with The ...",
  },
  {
    id: 7,
    image: vocaboost,
    title: "VocaBoost",
    description:
      "<b> Use idioms and phrasal verbs as part of your vocabulary.</b> Avoid confusion with similar words such as 'see,' 'look,' and 'watch.",
    level: "Hard",
    lessons: 11,
    students: 227,
    details: "Use idioms and phrasal verbs as part of your vocabulary. Avoid confusion with similar...",
  },
  {
    id: 8,
    image: ielts,
    title: "Ielts & Toeic",
    description:
      "<b>Improve your speaking, reading, listening, and writing. Focusing on both <b style='color:red;'>IELTS & TOEIC</b> provides you with a competitive edge.</b>",
    level: "Expert",
    lessons: 11,
    students: 227,
    details: "Improve your speaking, reading, listening, and writing. Focusing on both IELTS & TOEIC...",
  },
];

function CourseCard() {
  const navigate = useNavigate();
  const handleNavigation = (category, e) => {
    e.preventDefault();
    navigate(`/courses/${category}`);
  };
  useEffect(() => {
    Aos.init({ duration: 2000 });
  }, [])
  return (
    <div data-aos="fade-up">
      <h1 className="text-4xl font-semibold text-center mb-6 my-10">
        Learning focused on your goals With Our Courses
      </h1>
      <h3 className="text-center md:mx-40 mb-10">
        Empower Your Journey: Elevate Your English Speaking Skills with Our
        Targeted Courses. This subheading encapsulates the idea of focusing on
        learning goals and emphasizes the transformative potential of the
        English speaking courses offered.
      </h3>
      <div className="grid md:mx-20 lg:grid-cols-4 sm:grid-cols-2 mx-4 gap-12 mb-10 cursor-pointer">
        {courses.map((course) => (
          <Card
            data-aos='fade-up'
            key={course.id}
            sx={{
              maxWidth: 345,
              position: "relative",
              overflow: "hidden",
              borderRadius: 4,
              transition: "transform 0.2s",
              '&:hover': {
                transform: 'scale(1.05)',
              }
            }}
            onClick={(e) => handleNavigation(course.title, e)}
          >
            <CardMedia
              component="img"
              className="card-image"
              height="140"
              image={course.image}
              alt={course.title}
            />
            <CardContent>
              <Typography
                gutterBottom
                variant="h5"
                component="div"
                style={{ fontWeight: "bold" }}
              >
                {course.title}
              </Typography>
              <Typography
                variant="body2"
                color="text.secondary"
                dangerouslySetInnerHTML={{ __html: course.description }}
              />
              
                  {/* <Typography variant="h6">{course.level}</Typography>
                  <div className="info">
                    <Typography variant="body2">
                      <b>📘 {course.lessons} Lessons</b>
                    </Typography>
                    <Typography variant="body2">
                      <b>👤 {course.students} Students</b>
                    </Typography>
                  </div> */}

            </CardContent>
            <div className="overlay">
              <div className="overlay-content">
                <Typography variant="h4">{course.title}</Typography>
                {/* <Typography variant="h6">{course.level}</Typography> */}
                <Typography variant="body2">{course.details}</Typography>
                {/* <div className="info">
                  <Typography variant="body2">
                    <b>📘 {course.lessons} Lessons</b>
                  </Typography>
                  <Typography variant="body2">
                    <b>👤 {course.students} Students</b>
                  </Typography>
                </div> */}
                <button className="enroll-button">Read More ➔</button>
              </div>
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
}

export default CourseCard;
